import React, { useCallback } from 'react';
import { TMenuContentVersion } from 'types';
import { Checkbox, Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';

interface IUseRestaurantContentVersionCheckBox {
	toggleUseContentVersion: (value: TMenuContentVersion) => void;
	useContentVersion: TMenuContentVersion;
}

const UseRestaurantContentVersionCheckBox: React.FC<IUseRestaurantContentVersionCheckBox> = ({
	toggleUseContentVersion,
	useContentVersion,
}) => {
	const handleChange = useCallback(
		(e: CheckboxChangeEvent) => {
			if (e.target.checked) {
				toggleUseContentVersion('Restaurant');
			} else {
				toggleUseContentVersion('None');
			}
		},
		[toggleUseContentVersion],
	);

	return (
		<Form.Item name="useContentVersion">
			<Checkbox
				checked={useContentVersion === 'Restaurant'}
				onChange={handleChange}
				disabled={useContentVersion === 'Customer'}>
				<Text translationNameSpace="form" translationKey="useRestaurantContentVersionLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseRestaurantContentVersionCheckBox);
